// extracted by mini-css-extract-plugin
export default {"base":"ArchiveDialog_base__u1+fj","dateFilterSelect":"ArchiveDialog_dateFilterSelect__nGGTd","copyButton":"ArchiveDialog_copyButton__RGFR7"};